import React from 'react';
import {Image, Col} from 'react-bootstrap/lib/';
import TabNavigation from './TabNavigation';
import AccordionNavigation from './AccordionNavigation';
import { browserHistory } from 'react-router';
import AdminLink from './AdminLink';

export default class Header extends React.Component {
  constructor (props){
    super(props);
  }

  handleClick(){
    let dashboard_tab = this.props.tabData.filter(tab => tab.name.toUpperCase() === "DASHBOARD")[0];
    this.props.GlobalActions.storeHeaderTabs(this.props.tabData.map(storedTab => {
      if(storedTab.name.toUpperCase() === dashboard_tab.name.toUpperCase()){
        //Switch the Content to Dashboard
        dashboard_tab.onClick();
        //Switch the Dashboard Tab to be active:true and pass `open_link`
        return Object.assign({}, storedTab, {active: true})
      }
      return Object.assign({}, storedTab, {active: false})
    }));
  }

  render() {
    const style = {
      visibility : (this.props.isLoggedIn && !this.props.auth.details.force_pw_change) ? 'visible' : 'hidden'
    };

    //if this user has admin privileges, show the admin link in the header
    let adminLink = this.props.displayData && this.props.displayData.admin_link
        ? (<AdminLink admin={this.props.admin}/>)
        : null;

    if(this.props.isLoggedIn) {
      return (
        <div className="innerContainer">
          <div className="container-fluid" style={{padding:'0'}}>
            <div id="headerRow" className="nd-row">
              <Col xs={12} style={{padding:'0'}}>
                <Col xs={4}>
                  {this.props.displayData && this.props.displayData.logo_filename &&
                    <Image src={require('../../img/' + this.props.displayData.logo_filename)} id="headerLogo" style={{float:'left',cursor:'pointer'}} onClick={this.handleClick.bind(this)}/>
                  }
                </Col>
                <Col xs={4} style={{textAlign:'center'}}>
                  <h5 style={{color:'white', fontWeight:'bold', ...style}}>{this.props.displayData && this.props.displayData.org_label}</h5>
                  {this.props.displayData && this.props.displayData.banner && (
                    <h5 style={{color: 'white',fontWeight:'bold', fontStyle: 'italic', marginBottom: '-10px',...style}}>{this.props.displayData.banner}</h5>
                  )}
                </Col>
                <Col xs={4}>
                  <h5 style={{color:'white', float:'right', fontSize:'12px', paddingTop:'2px', ...style}}>{this.props.displayData && this.props.displayData.roster_label}</h5>
                </Col>
              </Col>
              <Col xs={12} style={{padding:'0'}}>
                <Col xs={6} smHidden={true} mdHidden={true} lgHidden={true}>
                  <div>
                    <AccordionNavigation tabData={this.props.tabData} currentPage={this.props.currentPage} view={this.props.view} />
                  </div>
                </Col>
                <Col xs={6} sm={12}>
                  <h5 style={{color:'white', float:'right', ...style}}>
                    <span className="header-link">{adminLink}</span>
                    <span className="header-link" onClick={this.submitLogout.bind(this)}><i>Log out</i></span>
                  </h5>
                </Col>
              </Col>
            </div>
            <div className="nd-row" style={style}>
              <Col xsHidden={true} sm={12}>
                <div style={style}>
                  <TabNavigation GlobalActions={this.props.GlobalActions} key={"headerNav" + this.props.admin} tabData={this.props.tabData} currentPage={this.props.currentPage} view={this.props.view} />
                </div>
              </Col>
            </div>
          </div>
        </div>
      );
    } else {
      //display default header
      return (
        <div className="innerContainer">
          <div className="container-fluid" style={{padding:'0'}}>
            <div id="headerRow" className="nd-row">
              <Col xs={6}>
                <Image src={require('../../img/netDutyLogo.png')} id="headerLogo" style={{float:'left', paddingBottom : '3px'}} />
              </Col>
            </div>
          </div>
        </div>
      )
    }
  }

  submitLogout() {
    this.props.GlobalActions.logout()
    .then(res => {
      console.log(res);
      browserHistory.push('login');
    })
  }

}



// WEBPACK FOOTER //
// ./src/components/AppLayout/Header.js